import { REACT_APP_DISABLE_CHECKOUT_PAYMENT_OPTIONS } from "../config";

export type PaymentMethod = {
  action: PaymentActions;
  issuers: string[];
};

export enum PaymentActions {
  PAY_LATER = "PAY_LATER",
  PAY_LATER_MONTHS = "PAY_LATER_MONTHS",
  PAY_LATER_TERMS = "PAY_LATER_TERMS",
  PAY_NOW = "PAY_NOW",
  PAY_FULL = "PAY_FULL",
  PAY_CUSTOM = "PAY_CUSTOM",
  BANK_TRANSFER = "BANK_TRANSFER",
}

export const iDealIssuers = [
  "ABNAMRO",
  "RABOBANK",
  "ING",
  "BUNQ",
  "SNSBANK",
  "KNAB",
  "ASNBANK",
  "VANLANSCHOT",
  "TRIODOSBANK",
  "SNSREGIOBANK",
];

export const paymentMethods: PaymentMethod[] = [
  {
    action: PaymentActions.PAY_LATER,
    issuers: [],
  },
  ...(REACT_APP_DISABLE_CHECKOUT_PAYMENT_OPTIONS !== "true"
    ? [
        {
          action: PaymentActions.PAY_NOW,
          issuers: iDealIssuers,
        },
        {
          action: PaymentActions.PAY_FULL,
          issuers: iDealIssuers,
        },
      ]
    : []),
];

export const paymentMethodsCheckout: PaymentMethod[] = [
  {
    action: PaymentActions.PAY_LATER,
    issuers: [],
  },
];

export const paymentMethodsPayment: PaymentMethod[] = [
  {
    action: PaymentActions.PAY_NOW,
    issuers: iDealIssuers,
  },
  {
    action: PaymentActions.PAY_FULL,
    issuers: iDealIssuers,
  },
];

export const paymentMethodsCustom: PaymentMethod[] = [
  { action: PaymentActions.PAY_CUSTOM, issuers: iDealIssuers },
];

export const deferredPaymentMethods: PaymentMethod[] =
  paymentMethodsPayment.filter((method) =>
    [PaymentActions.PAY_NOW, PaymentActions.PAY_FULL].includes(method.action),
  );
